import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableInviteUserOnboarding = Loadable({
  loader: function loader() {
    return import('../InviteUserOnboarding.jsx');
  },
  loading: ComponentLoading
});
export default LoadableInviteUserOnboarding;